import { makeAction } from '@va/store';
import * as Types from './types';

export const signUpPromoter = makeAction(Types.FIRST_PROMOTER_SIGN_UP);
export const signUpPromoterSucceeded = makeAction(Types.FIRST_PROMOTER_SIGN_UP_SUCCEEDED, 'data');
export const signUpPromoterFailed = makeAction(Types.FIRST_PROMOTER_SIGN_UP_FAILED, 'error');
